<template>
  <v-navigation-drawer
    :width="navWidth"
    app
    :clipped="$vuetify.breakpoint.smAndUp"
    v-model="localNavDrawer"
    mobile-breakpoint="960"
  >
    <h4 class="ma-4">Menú</h4>

    <navLinks />
  </v-navigation-drawer>
</template>

<script>
import NavLinks from "@/layouts/intranet/components/NavLinks.vue"

export default {
  components: {
    NavLinks,
  },
  props: {
    navDrawer: Boolean,
  },
  data: () => ({
    navWidth: 200,
  }),
  computed: {
    localNavDrawer: {
      get() {
        return this.navDrawer
      },
      set(value) {
        this.$emit("toggleMenu", value)
      },
    },
  },
}
</script>

<style lang="scss" scoped></style>
